import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import Block from "../components/block";
import { Spin } from "antd";
import { useNavigate } from "react-router-dom";

const Logout: React.FC = () => {
    const { logout, isAuthenticated } = useAuth();
    const navigate = useNavigate();
    const [isLoggingOut, setIsLoggingOut] = useState(false);

    useEffect(() => {
        const performLogout = async () => {
            setIsLoggingOut(true);
            try {
                await logout();
                navigate("/user-login", { replace: true });
            } catch (error) {
                console.error("Logout failed:", error);
                navigate("/user-login", { replace: true });
            }
        };

        if (isAuthenticated) {
            performLogout();
        }
    }, [isAuthenticated, logout, navigate]);

    // Show loading spinner during logout process or if authenticated
    if (isLoggingOut || isAuthenticated) {
        return (
            <div className="flex justify-center bg-white items-center h-32 p-8 m-auto">
                <Spin size="large" />
            </div>
        );
    }

    setTimeout(() => {
        navigate("/user-login", { replace: true });
    }, 2000);

    // Only show unauthorized message if no token and not logging out
    return (
        <Block>
            <h1 className='text-red-600 text-4xl text-center'>Unauthorized request!!</h1>
            <p className='text-gray-500 text-lg text-center'>Please login again.</p>
        </Block>
    );
};

export default Logout;